import { useEffect, useRef } from "react";
import { trackEvent } from "./mixpanel";

export const useScreenTracking = (eventName, properties = {}) => {
    const startTime = useRef(Date.now());
    const timeoutRef = useRef(null);

    useEffect(() => {
        // Start timer when entering the screen
        startTime.current = Date.now();

        // Clear any pending tracking
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        return () => {
            timeoutRef.current = setTimeout(() => {
                const timeSpent = Math.round(
                    (Date.now() - startTime.current) / 1000
                );

                trackEvent(eventName, {
                    ...properties,
                    "Time spent on screen": timeSpent,
                });

                timeoutRef.current = null;
            }, 0);
        };
    }, [eventName]);

    const getTimeSpent = () => {
        return Math.round(
            (Date.now() - startTime.current) / 1000
        );
    };

    return {
        getTimeSpent,
    };
};